import { Input, Modal, ModalBody } from "reactstrap";
import { newValidatePhone, validateEmail } from "../../../../helpers/functions";
import { useState } from "react";
import { ButtonLoading } from "../../../../components/buttons/button-loading";
import { useUsersAdminAction } from "../../../../services/actions/users-admin.actions";
import toast from "react-hot-toast";
import { v4 as uuidv4 } from "uuid";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../../services/atoms/auth.atoms";

const initialDataStates = {
  name: "",
  userEmail: "",
  usersPhone: "",
};

const CreateUserAdminModal = (props) => {
  const { open, toggle, clientId, clientName } = props;
  const [data, setData] = useState(initialDataStates);
  const [isUserAdmin, setIsUserAdmin] = useState(true);
  const { createUsersAdmin, usersAdminsList} = useUsersAdminAction();
  const user = useRecoilValue(userAtom)

  const handleChange = (key, value) =>
    setData((prevValues) => ({ ...prevValues, [key]: value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    const formdata = new FormData(e.target);
    let newData = {
      ...Object.fromEntries(formdata.entries()),
      clientId,
      clientName,
      isAdmin: isUserAdmin,
      isBasic: !isUserAdmin,
      id: uuidv4()
    };
    createUsersAdmin(newData, (result) => {
      const status = result?.status ?? result?.response?.status;
      const isSuccess = status >= 200 && status < 300;

      if (!isSuccess) {
        const message =
          result?.response?.data?.message ||
          result?.data?.message ||
          "No se pudo crear el usuario";
        toast.error(message, { duration: 4000 });
        return;
      }

      toggle();
      // El back ya no asigna contraseña: envía una invitación para que la persona cree la suya.
      if (result?.data?.invited === false) {
        toast(result?.data?.message || "Usuario creado, pero no se pudo enviar la invitación. Reenvíala desde Usuarios.", { duration: 6000 });
      } else {
        toast.success(`Invitación enviada a ${newData.userEmail}`, { duration: 4000 });
      }
      usersAdminsList(clientName)
    });
  };

  return (
    <Modal isOpen={open} toggle={toggle}>
      <div className="gm-modal-header">
        <div className="gm-modal-title-container">
          <div className="gm-modal-title">Crear Usuario</div>
        </div>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={toggle}
        />
      </div>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <div className="gm-modal-form-container">
            <div className="gm-modal-form-section">
              <div className="gm-modal-form-group">
                <div className="gm-modal-input-group">
                  <label htmlFor="name">Nombre</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    placeholder="Nombre Apellido"
                  />
                </div>
                <div className="gm-modal-input-group">
                  <label htmlFor="userEmail">Correo</label>
                  <Input
                    type="email"
                    id="userEmail"
                    name="userEmail"
                    onChange={(e) => handleChange("userEmail", e.target.value)}
                    maxLength={90}
                    invalid={validateEmail(data.userEmail)}
                    required
                    placeholder="email@correo.com"
                  />
                </div>
                <div className="gm-modal-input-group">
                  <label htmlFor="usersPhone ">Teléfono</label>
                  <Input
                    type="text"
                    id="usersPhone"
                    name="usersPhone"
                    onChange={(e) => handleChange("usersPhone", e.target.value)}
                    maxLength={20}
                    invalid={!newValidatePhone(data.usersPhone)}
                    placeholder="+569 1234 5678"
                  />
                </div>
                <div className="gm-modal-input-group">
                  <label htmlFor="origenCollaborator">Rol</label>
                  <select
                    onChange={() => {
                      setIsUserAdmin(!isUserAdmin);
                    }}
                    required
                  >
                    {(user?.data?.isAdmin ||
                      user?.data?.isSuperAdmin) && (
                        <option value="externo">Administrador Empresa</option>
                      )}
                    <option value="interno">Analista</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="gm-modal-buttons">
            <button
              type="button"
              className="gm-secondary-button"
              onClick={toggle}
            >
              Cancelar
            </button>
            <ButtonLoading
              className="gm-primary-button"
              type="submit"
              buttonLabel="Crear"
              disabled={
                data.userEmail === "" ||
                validateEmail(data.userEmail) ||
                data.usersPhone === "" ||
                !newValidatePhone(data.usersPhone)
              }
            />
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default CreateUserAdminModal;
